import { roleValidator } from '@/services/roleValidator'
import router from '@/router'

const oidcEvents = {
  userLoaded: (user) => {
    console.log('OIDC user is loaded:', user)
    if (!roleValidator(user.profile)) {
      router.push('/pages/about') // .catch(err => {})
    }
  },
  userUnloaded: () => console.log('OIDC user is unloaded'),
  accessTokenExpiring: () => console.log('Access token will expire'),
  accessTokenExpired: () => console.log('Access token did expire'),
  silentRenewError: () => console.log('OIDC user is unloaded'),
  userSignedOut: () => console.log('OIDC user is signed out'),
  oidcError: (payload) => console.log('OIDC error', payload),
}

export default oidcEvents
